export const mapIAPTypeToReadableString = (type: string): string => {
  const typeMapping: Record<string, string> = {
    CONSUMABLE: "Consumable",
    NON_CONSUMABLE: "Non Consumable",
    SUBSCRIPTION: "Subscription",
  };
  return typeMapping[type] || type;
};

export const mapIAPStatusToReadableString = (status: string): string => {
  const statusMapping: Record<string, string> = {
    DRAFT: "Draft",
    PENDING: "Pending",
    IN_REVIEW: "In review",
    APPROVED: "Approved",
    REJECTED: "Rejected",
    ERRORED: "Errored",
    PENDING_PRICE_CHANGE: "Pending price change",
    ERROR_SETTING_PRICE: "Error setting price",
  };
  return statusMapping[status] || status;
};
